import React from 'react';
import Navbar from '../components/Navbar';
import SeasonalBanner from '../components/SeasonalBanner';
import Pates from '../components/Pates';
import SavoirFaire from '../components/SavoirFaire';
import Footer from '../components/Footer';
import { useLang } from '../LanguageContext';
import { ThemeProvider, useTheme } from '../ThemeContext';

const Inner = () => {
  const { t } = useLang();
  const theme = useTheme();
  return (
    <div className="min-h-screen" style={{ background: '#f6ecd9' }}>
      <SeasonalBanner />
      <Navbar />
      <section className="relative pb-20 overflow-hidden" style={{ background: theme.primary, paddingTop: 'calc(var(--banner-h, 0px) + 160px)' }}>
        <div
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage: 'radial-gradient(#d4a94c 1px, transparent 1px)',
            backgroundSize: '28px 28px'
          }}
        />
        <div className="relative max-w-6xl mx-auto px-6">
          <p className="text-[11px] tracking-[0.35em] uppercase text-[#d4a94c] mb-6 fade-up">
            {t.page.catPates}
          </p>
          <h1 className="font-serif text-5xl md:text-7xl text-[#f6ecd9] leading-[1.05] fade-up fade-up-delay-1">
            {t.page.catPatesT1} <em className="italic font-light text-[#d4a94c]">{t.page.catPatesT1b}</em>{t.page.catPatesT2}
          </h1>
          <p className="text-[#f6ecd9]/75 text-base md:text-lg mt-8 max-w-2xl leading-relaxed fade-up fade-up-delay-2">
            {t.page.catPatesDesc}
          </p>
        </div>
      </section>
      <Pates />
      <SavoirFaire variant="pate" />
      <Footer />
    </div>
  );
};

const PatesPage = () => (
  <ThemeProvider name="blue">
    <Inner />
  </ThemeProvider>
);

export default PatesPage;
